import { Box, List, ListItem, Typography } from "@mui/material";
import { faCircle } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HierarchyType from "@/src/_types/Page/hierarchy";
import Journal from "@/src/_types/journal";
import Link from "@mui/material/Link";
import NextLink from "next/link";

const Hierarchy = ({ hierarchies, journal, pageSlug }: {
    hierarchies: HierarchyType[],
    journal: Journal,
    pageSlug: string
}) => {
    const listStyle = {
        pb: 0,
        '& .MuiListItem-root': {
            pt: 0,
            pb: '.25rem',
            pl: '1rem',
            pr: 0,
            fontSize: '.8rem',
            fontWeight: 'bold',
            color: '#788b8b',
            textDecoration: 'none',
            flexWrap: 'wrap',
            flexDirection: 'row',
            wordWrap: 'break-word',
            ' a': {
                transition: 'all eas-in-out .3s',
                color: 'custom.textColorHierarchy',
                display: 'flex',
                alignItems: 'flex-start',
                textDecoration: 'none',
                fontWeight: 'bold',
                fontSize: '.875rem',
                '&:hover': {
                    cursor: 'pointer',
                    transform: 'scale(1.03)',
                    color: 'primary.main',
                },
            },
        }
    }

    const renderPages = (
        pages: HierarchyType[], 
        journal: Journal
    ) => {
        return (
            <List sx={listStyle}>
                {
                    pages.map((page, index: number) => (
                        <ListItem key={index}>
                            <Link
                                component={NextLink}
                                sx={{
                                    ...(page.slug === pageSlug && {
                                        color: '#0c7f8b !important',
                                        transform: 'scale(1.05)'
                                    }),
                                }}
                                href={journal.is_main_site ?
                                    `${page?.path}` :
                                    `/${journal.journal_url}${page?.path}`}
                                data-slug={pageSlug}
                                data-slugs={index}>
                                {
                                    page.slug !== pageSlug && (
                                        <FontAwesomeIcon
                                            icon={faCircle}
                                            fontSize={5}
                                            style={{
                                                marginTop: 6,
                                                marginRight: 5
                                            }}
                                        />
                                    )
                                }
                                {page.title}
                            </Link>
                            {
                                page.childes && page.childes.length > 0 && (
                                    renderPages(
                                        page.childes, 
                                        journal
                                    )
                                )
                            }
                        </ListItem>
                    ))
                }
            </List>
        );
    };

    if (hierarchies && hierarchies.length > 0) {
        return (
            <Box
                bgcolor="custom.middleGray"
                borderRadius={2}
                p={1}
            >
                <Typography
                    fontWeight="bold"
                    variant="h3"
                    color="custom.hierarchyTitleColor"
                    fontSize={'.975rem'}
                    marginBottom={.4}
                >
                    Pages
                </Typography>
                {
                    renderPages(
                        hierarchies,
                        journal
                    )
                }
            </Box>
        );
    }
}

export default Hierarchy;
